import { z } from 'zod';

import { blockBaseSchema } from '../base';
import { blockCommonDataShape } from '../shared';

/**
 * The header/footer block. Its rows are the three fixed slots, and on top of the
 * shared settings it styles the burger menu it collapses into on a narrow
 * screen.
 *
 * `hideWidgetsOnMobile` is keyed by widget id — the header hides individual
 * widgets rather than whole rows.
 */
export const blockSpecificDataSchema = z.object({
    ...blockCommonDataShape,

    /** `EHorizontalPosition` / `ESize` — host enums, kept as persisted literals. */
    icon: z.object({
        horizontalPosition: z.string(),
        size: z.string(),
        color: z.string(),
    }),
    textColor: z.string(),
    horizontalPosition: z.string(),
    hideContentOnMobile: z.boolean(),
    hasSeparator: z.boolean(),
    hideWidgetsOnMobile: z.record(z.string(), z.boolean()),
});

export const blockSpecificSchema = blockBaseSchema.extend({
    entitySubType: z.literal('specific'),
    props: blockSpecificDataSchema,
    version: z.literal(0),
});

export const blockSpecificV0Schema = blockSpecificSchema;
export type BlockSpecificV0 = z.infer<typeof blockSpecificV0Schema>;
